import { endOfDay, startOfDay, subDays } from 'date-fns'

import { DateInterval } from 'helpers/date.helpers'

export const DAYS_BACK = {
  last30: 29,
  last60: 59,
  last90: 89,
  last120: 119,
} as const

export type MetricsPeriod = keyof typeof DAYS_BACK | 'custom'

export const resolveMetricsPeriod = <TPeriod extends MetricsPeriod>(
  period: TPeriod,
): DateInterval => {
  const now = new Date()
  const periodKey: keyof typeof DAYS_BACK =
    period === 'custom' ? 'last30' : (period as keyof typeof DAYS_BACK)
  const daysBack = DAYS_BACK[periodKey]

  return { start: startOfDay(subDays(now, daysBack)), end: endOfDay(now) }
}
